import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-detail-devis',
  templateUrl: './empty-detail-devis.component.html',
  styleUrls: ['./empty-detail-devis.component.css']
})
export class EmptyDetailDevisComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
